<template>
<div class="workflow-child">
    <div class="report-image-grid" v-if="(graphs && graphs.length>0)">

            <div class="card-grid-item" v-for="graph in graphs" :graph="graph" :key="graph.graphid">
                <h3 class="search-listing-title"><a class="search-candidate-title"><i v-bind:class="['search-listing-icon', graph['iconclass']]"></i> <span>{{graph["name"]}}</span></a></h3>

                <div class="search-listing-body">{{graph['description']}}</div>

                <div class="search-listing-footer">
                    <!--ko if: provisional_resource == 'true' --><!--/ko-->

                    <!--ko if: provisional_resource == 'partial' && $parent.userIsReviewer --><!--/ko-->


                    
                    <a class="search-candidate-link"  data-bind="visible: point, click: mapLinkClicked" style="display: none;"><i class="fa fa-map-marker"></i>  </a>

                    <!--ko ifnot: $root.resourceEditorContext -->
                    
                    <a class="search-candidate-link pull-right"  @click="$emit('card-create-event',{'topic': 'graph-selected','graph':graph})">
                        <i class="fa fa-check-circle"></i>  
                        Seleziona
                    </a>
                    
                    <!--/ko-->
                    <!--ko if: $root.resourceEditorContext --><!--/ko-->

                </div>
            </div>

    </div>
<!--     <div class="block" v-else>
        <span>Nessun risultato ...</span>
    </div> -->
    <div class="card-grid-item report-modal" v-else>
      <div class="block">
        <h3 class="circle">
          Nessun risultato
        </h3>
      </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'CardTypeSelect',
        props: {
            graphs: {
                type: Array,
                value: []
            }
        },
        methods: {

        }

    }
</script>

<style scoped>
    .panel {
        width: 240px;
    }
    .panel-body {
        font-size: 12px;
        text-align: left;
        overflow: hidden;
        width: 160px;
        height: 80px;
        white-space: wrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    .panel-heading {
        color: darkcyan;
        text-align: left;
        font-size: 16px;
    }

    .panel-heading > * {
        margin-left: 4px;
    }

    .card-grid-item.report-modal {
        min-height: 240px;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        text-align: center;
        display: table;
        width: 100%;
        border: 0px;
        }

    #app .block {
        display: table-cell;
        vertical-align: middle;
        background-color: #ebeef0;
        }

    #app .card-grid-item {
        cursor: default;
    }

</style>